import { useQuery } from "react-query";
import { useXeroClient } from "../hooks";

export const useXeroOrganisationQuery = (config = {}) => {
  const xero = useXeroClient();

  return useQuery({
    queryKey: ["xero_organisation"],
    queryFn: async () => {
      return xero.get("organisations").get("data").get(0);
    },
    ...config,
  });
};
